function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.755 32.585h0l2.049 2.053c.598.6 1.433 1.1 2.274 1.448.84.349 1.784.588 2.63.588h38.89c.797 0 1.458.66 1.458 1.464v40.398c0 .805-.66 1.464-1.458 1.464H2.458A1.468 1.468 0 011 78.536V32.6c0-.805.66-1.464 1.458-1.464h11.809c.505 0 1.182.153 1.863.436.68.282 1.267.654 1.625 1.013z",
  fill: "#CEE3F6",
  stroke: "#73A3CD",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.303 16.64l.009.009.009.01 5.585 5.89-.05 38.266a.287.287 0 01-.287.286H26.206a.287.287 0 01-.287-.286V9.589c0-.16.13-.288.29-.287l27.689.221 6.405 7.116z",
  fill: "#fff",
  stroke: "#E5E5E5",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.15 9.044v13.319c0 .473.383.858.857.858h11.744",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeDasharray: "1.12 1.12"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31.579 16.889H42.53M34.908 22.39H45.86M34.908 27.892H51M34.908 54.747H51M31.579 33.394h8.324M34.908 38.895h6.104M34.908 44.397h8.878M31.579 49.899H42.53",
  stroke: "#EBB55C",
  strokeWidth: 1.232,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M42.88 9.33l.01.009.008.01 5.586 5.89-.051 38.266a.287.287 0 01-.287.286H8.784a.287.287 0 01-.287-.286V2.278c0-.159.13-.288.289-.286l27.69.22L42.88 9.33z",
  fill: "#fff",
  stroke: "#E5E5E5",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M35.624 1.862v13.19c0 .474.385.858.858.858H48.33",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeDasharray: "1.12 1.12"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.156 9.578h10.952M17.486 15.08h10.952",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.486 20.582h16.093M17.486 47.437h16.093",
  stroke: "#EBB55C",
  strokeWidth: 1.232,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.156 26.084h8.324",
  stroke: "#E5E5E5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.486 31.585h6.104M17.486 37.087h8.879",
  stroke: "#EBB55C",
  strokeWidth: 1.232,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M50.922 27.686l.008.01.01.01 5.585 5.89-.051 38.266a.287.287 0 01-.287.286H16.825a.287.287 0 01-.287-.286V20.635c0-.159.13-.288.289-.286l27.69.221 6.405 7.116z",
  fill: "#fff",
  stroke: "#C5C5C5",
  strokeWidth: 2
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.866 28.563H36.91",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M19.536 23.983h14.839",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeDasharray: "4.06 4.06"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M19.866 33.143l21.504.032",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M19.866 37.722h4.464",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M27.17 37.722h10.857",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 42.302h9.943",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M34.476 42.302H36.2",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 46.882h8.117",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M32.65 46.882h19.074",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 51.462h4.058",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M28.895 51.462h14.61",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M23.518 56.041h13.393",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M39.853 56.041h6.392",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M25.344 60.62h6.29",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M34.374 60.62h1.827",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M19.866 65.2h4.464",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M27.17 65.2h10.857",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 69.78h9.943",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M34.476 69.78H36.2",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 74.36h8.117",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M32.65 74.36h19.074",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M21.692 78.94h4.058",
  stroke: "#9B9B9B",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M28.895 78.94h14.61",
  stroke: "#C5C5C5",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M44.243 20.249v13.22c0 .473.384.857.858.857h11.783",
  stroke: "#C5C5C5",
  strokeWidth: 2
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M1.01 78.192l.002-.014v-.014l3.254-36.47c.106-.84.912-1.552 1.751-1.552h62.294c.741 0 1.229.557 1.124 1.3l-.001.011-.002.012-4.294 36.487c-.126.846-.963 1.57-1.811 1.57H2.187c-.75 0-1.266-.577-1.177-1.33z",
  fill: "#CEE3F7",
  stroke: "#73A3CD",
  strokeWidth: 2
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M2.757 32.754l7.583-7.425c-.584-.74-1.03-1.546-1.407-2.386a11.183 11.183 0 01-.892-4.367c0-1.512.309-2.99.892-4.368a11.291 11.291 0 012.47-3.595 11.556 11.556 0 013.671-2.419 11.841 11.841 0 014.46-.874c1.544 0 3.054.303 4.46.874a11.556 11.556 0 013.672 2.419 11.29 11.29 0 012.47 3.595c.583 1.377.892 2.856.892 4.368 0 1.511-.309 2.99-.892 4.367a11.29 11.29 0 01-2.47 3.595 11.557 11.557 0 01-3.672 2.42 11.84 11.84 0 01-4.46.873 11.84 11.84 0 01-4.46-.874c-.892-.37-1.68-.84-2.436-1.377l-7.582 7.425c-.309.302-.72.47-1.132.47-.412 0-.823-.168-1.132-.47-.652-.639-.652-1.646-.035-2.251zM19.5 27.31c4.94 0 8.955-3.93 8.955-8.769 0-4.838-4.014-8.769-8.955-8.769-4.94 0-8.954 3.931-8.954 8.77 0 2.116.754 4.03 2.024 5.543.377.436.789.873 1.27 1.243a9.032 9.032 0 005.66 1.982z",
  fill: "#4A4A4A"
});

var SvgAnalyze = function SvgAnalyze(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

export default "data:image/svg+xml;base64,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";
export { SvgAnalyze as ReactComponent };